const DASH_DOMAIN_HEADER = 'dash-domain';

/**
 * Builds the headers for a JSON POST to the dash API. The registration's edit key in
 * the URL is the credential on every action, so no antiforgery token is needed; the
 * dash-domain header lets the dev-server proxy carry the branded hostname.
 */
export const buildPostHeaders = (): Record<string, string> => ({
    'Content-Type': 'application/json',
    [DASH_DOMAIN_HEADER]: window.location.hostname,
});
